var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSortAsc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0H5V8.61926L3.5579 7.15006C3.46574 7.05462 3.33959 7.00084 3.2079 7.00084C3.07621 7.00084 2.95006 7.05462 2.8579 7.15006L2.1479 7.87045C2.05324 7.96571 2 8.09538 2 8.23065C2 8.36591 2.05324 8.49558 2.1479 8.59084L5.2779 11.7768C5.41962 11.9177 5.60948 11.9977 5.8079 12H6.1879C6.38674 11.9998 6.57738 11.9195 6.7179 11.7768L9.8479 8.59084C9.94256 8.49558 9.9958 8.36591 9.9958 8.23065C9.9958 8.09538 9.94256 7.96571 9.8479 7.87045L9.1479 7.15006C9.05402 7.05402 8.92622 7 8.7929 7C8.65958 7 8.53178 7.05402 8.4379 7.15006L7 8.61498V0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSortAsc);
export default __webpack_public_path__ + "static/media/arrow-sort-asc.fe410fdff326d4af103bf4aa0730ab89.svg";
export { ForwardRef as ReactComponent };